export default "__VITE_ASSET__b95d2714__"